import React, { useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import { Card } from 'semantic-ui-react';
import '../App.css';

function Experience(props) {
  const cardStyle = {
    backgroundColor: '#1E1E1E',
    marginTop: '5px',
  };

  useEffect(() => {
    // Update document title
    document.title = 'Albert Nguyen | Experience';
  });

  return (
    <div style={props.style}>
      <PageHeader title='Experience' isDesktop={props.isDesktop} />
      <div className='contentScroll'>
        <Card.Group centered itemsPerRow={1} style={{ marginTop: '5px' }}>
        <Card style={cardStyle}>
            <Card.Content>
              <Card.Header
                style={{ color: '#F4F4F4' }}
                content='Teambridge | Senior Full-Stack Software Engineer'
              />
              <Card.Meta
                style={{ color: '#A4A4A4' }}
                content='October 2021 - Current'
              />
              <Card.Description style={{ color: '#D4D4D4' }}>
                Building full-stack solutions from seed to Series B. Led technical implementation for major customer launches,
                built backend systems for document template editors, redesigned data table performance achieving 2-5x improvements,
                and implemented geocoding APIs with PostGIS for map-based features.
              </Card.Description>
            </Card.Content>
          </Card>

          <Card style={cardStyle}>
            <Card.Content>
              <Card.Header
                style={{ color: '#F4F4F4' }}
                content='Sweep Energy | Software Engineer'
              />
              <Card.Meta
                style={{ color: '#A4A4A4' }}
                content='July 2019 - October 2021'
              />
              <Card.Description style={{ color: '#D4D4D4' }}>
                Started as an intern building the Electron desktop app for
                cross-platform compatibility and optimizing the API Gateway
                using Node.js. Transitioned to part-time engineer, leading
                front-end architecture for the hybrid app using Angular and
                Ionic — including the login system, directory, data charts,
                and complex reactive forms.
              </Card.Description>
            </Card.Content>
          </Card>
        </Card.Group>
      </div>
    </div>
  );
}

export default Experience;
